const NUMBRO_LOCALES = {
  de: 'de-DE',
  en: 'en-US',
};

export default NUMBRO_LOCALES;
